import ReportActionTypes from "./actionTypes";
import { fork, take, call, put } from "redux-saga/effects";
import "react-toastify/dist/ReactToastify.css";
import { ReportService } from "./service";
import { toast } from "react-toastify";
import moment from "moment";
import I18n from "../../trans/i18n";

export function* weatherHistoryRequest() {
  while (true) {
    let { params } = yield take(
      ReportActionTypes.WEATHER_HISTORY_REPORT_REQUEST
    );

    var weather_history = yield call(ReportService.getWeatherHistory, params);

    if (typeof weather_history === "object") {
      weather_history = weather_history.map((item) => {
        let device_id = item.device_id ? `-${item.device_id}` : "";
        return {
          ...item,
          ...{
            created_at:
              moment(item.created_at).format("DD/MM/YYYY") +
              " " +
              moment(item.created_at).format("HH:mm:ss"),
          },
          ...{ year: moment(item.created_at).year() },
          ...{ week: moment(item.created_at).isoWeek() },
          ...{ hour: moment(item.created_at).hour() },
          ...{ id: `${item.umva_id}${device_id}` },
        };
      });

      if (weather_history) {
        if (Object.values(weather_history).length > 0) {
          if (!"error" in weather_history) {
            yield put({
              type: ReportActionTypes.WEATHER_HISTORY_REPORT_FAILURE,
            });
          } else {
            yield put({
              type: ReportActionTypes.WEATHER_HISTORY_REPORT_SUCCESS,
              weather_history: weather_history,
            });
          }
        } else {
          toast.error("No content in the report", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          yield put({
            type: ReportActionTypes.WEATHER_HISTORY_REPORT_FAILURE,
          });
        }
      } else {
        yield put({
          type: ReportActionTypes.WEATHER_HISTORY_REPORT_FAILURE,
        });
      }
    } else {
      toast.error("No content in the report", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      yield put({
        type: ReportActionTypes.WEATHER_HISTORY_REPORT_FAILURE,
      });
    }
  }
}

export function* watchCountRequest() {
  while (true) {
    let { params } = yield take(ReportActionTypes.WATCH_COUNT_REPORT_REQUEST);

    var watch_count = yield call(ReportService.getWatchCountReport, params);

    if (typeof watch_count === "object") {
      watch_count = watch_count.map((item) => {
        let device_id = item.device_id ? `-${item.device_id}` : "";
        return {
          ...item,
          ...{ created_at: moment(item.created_at).format("DD/MM/YYYY") },
          ...{ year: moment(item.created_at).year() },
          ...{ week: moment(item.created_at).isoWeek() },
          ...{ hour: moment(item.created_at).hour() },
          ...{ id: `${item.user}${device_id}` },
        };
      });

      if (watch_count) {
        if (Object.values(watch_count).length > 0) {
          if (!"error" in watch_count) {
            yield put({
              type: ReportActionTypes.WATCH_COUNT_REPORT_FAILURE,
            });
          } else {
            yield put({
              type: ReportActionTypes.WATCH_COUNT_REPORT_SUCCESS,
              watch_count: watch_count,
            });
          }
        } else {
          toast.error("No content in the report", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          yield put({
            type: ReportActionTypes.WATCH_COUNT_REPORT_FAILURE,
          });
        }
      } else {
        yield put({
          type: ReportActionTypes.WEATHER_HISTORY_REPORT_FAILURE,
        });
      }
    } else {
      toast.error("No content in the report", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      yield put({
        type: ReportActionTypes.WATCH_COUNT_REPORT_FAILURE,
      });
    }
  }
}

export function* userInstallationRequest() {
  while (true) {
    let { params } = yield take(
      ReportActionTypes.USER_INSTALLATION_REPORT_REQUEST
    );

    var user_installation = yield call(
      ReportService.getUserInstallationReport,
      params
    );

    if (typeof user_installation === "object") {
      user_installation = user_installation.map((item) => {
        let device_id = item.device_id ? `-${item.device_id}` : "";
        return {
          ...item,
          ...{ country: item?.country_address?.country },
          ...{ province: item?.country_address?.area1 },
          ...{ commune: item?.country_address?.area2 },
          ...{ zone: item?.country_address?.area3 },
          ...{ colline: item?.country_address?.area4 },
          ...{ locality: item?.country_address?.area5 },
          ...{ group: item?.country_address?.group },
          ...{ created_at: moment(item.created_at).format("DD/MM/YYYY") },
          ...{ year: moment(item.created_at).year() },
          ...{ week: moment(item.created_at).isoWeek() },
          ...{ hour: moment(item.created_at).hour() },
          ...{ id: `${item.umva_id}${device_id}` },
        };
      });

      if (user_installation) {
        if (Object.values(user_installation).length > 0) {
          if (!"error" in user_installation) {
            yield put({
              type: ReportActionTypes.USER_INSTALLATION_REPORT_FAILURE,
            });
          } else {
            yield put({
              type: ReportActionTypes.USER_INSTALLATION_REPORT_SUCCESS,
              user_installation: user_installation,
            });
          }
        } else {
          toast.error("No content in the report", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          yield put({
            type: ReportActionTypes.USER_INSTALLATION_REPORT_FAILURE,
          });
        }
      } else {
        yield put({
          type: ReportActionTypes.USER_INSTALLATION_REPORT_FAILURE,
        });
      }
    } else {
      toast.error("No content in the report", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      yield put({
        type: ReportActionTypes.USER_INSTALLATION_REPORT_FAILURE,
      });
    }
  }
}

export function* reviewsRequest() {
  while (true) {
    let { params } = yield take(ReportActionTypes.REVIEWS_REPORT_REQUEST);

    var reviews = yield call(ReportService.getReviewsReport, params);

    if (typeof reviews === "object") {
      reviews = reviews.map((item) => {
        let device_id = item.device_id ? `-${item.device_id}` : "";
        return {
          ...item,
          ...{ created_at: moment(item?.created_at).format("DD/MM/YYYY") },
          ...{ country: item?.country },
          ...{ province: item?.procince },
          ...{ commune: item?.commune },
          ...{ zone: item?.zone },
          ...{ colline: item?.zolline },
          ...{ locality: item?.locality },
          ...{ group: item?.group },
          ...{ reviewed_at: moment(item.reviewed_at).format("DD/MM/YYYY") },
          ...{ year: moment(item.reviewed_at).year() },
          ...{ week: moment(item.reviewed_at).isoWeek() },
          ...{ hour: moment(item.reviewed_at).hour() },
          ...{ id: `${item.user}${device_id}` },
          ...{ review: I18n.t(item.review) },
        };
      });

      if (reviews) {
        if (Object.values(reviews).length > 0) {
          if (!"error" in reviews) {
            yield put({
              type: ReportActionTypes.REVIEWS_REPORT_FAILURE,
            });
          } else {
            yield put({
              type: ReportActionTypes.REVIEWS_REPORT_SUCCESS,
              reviews: reviews,
            });
          }
        } else {
          toast.error("No content in the report", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          yield put({
            type: ReportActionTypes.REVIEWS_REPORT_FAILURE,
          });
        }
      } else {
        yield put({
          type: ReportActionTypes.REVIEWS_REPORT_FAILURE,
        });
      }
    } else {
      toast.error("No content in the report", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      yield put({
        type: ReportActionTypes.REVIEWS_REPORT_FAILURE,
      });
    }
  }
}

export function* ActivityTrackingRequest() {
  while (true) {
    let { params } = yield take(
      ReportActionTypes.ACTIVITY_TRACKING_REPORT_REQUEST
    );

    var activity_trackings = yield call(
      ReportService.getActivityTrackingsReport,
      params
    );

    if (typeof activity_trackings === "object") {
      activity_trackings = activity_trackings.map((item) => {
        let device_id = item.device_id ? `-${item.device_id}` : "";
        return {
          ...item,
          ...{ created_at: moment(item?.created_at).format("DD/MM/YYYY") },
          ...{ country: item?.country },
          ...{ province: item?.province },
          ...{ commune: item?.commune },
          ...{ zone: item?.zone },
          ...{ colline: item?.colline },
          ...{ locality: item?.locality },
          ...{ group: item?.group },
          ...{
            reviewed_at: moment(item.clicked_date_time).format("DD/MM/YYYY"),
          },
          ...{ year: moment(item.clicked_date_time).year() },
          ...{ week: moment(item.clicked_date_time).isoWeek() },
          ...{ hour: moment(item.clicked_date_time).hour() },
          ...{ id: `${item.user}${device_id}` },
          ...{ menu: I18n.t(item.menu) },
        };
      });

      if (activity_trackings) {
        if (Object.values(activity_trackings).length > 0) {
          if (!"error" in activity_trackings) {
            yield put({
              type: ReportActionTypes.ACTIVITY_TRACKING_REPORT_FAILURE,
            });
          } else {
            yield put({
              type: ReportActionTypes.ACTIVITY_TRACKING_REPORT_SUCCESS,
              activity_trackings: activity_trackings,
            });
          }
        } else {
          toast.error("No content in the report", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          yield put({
            type: ReportActionTypes.ACTIVITY_TRACKING_REPORT_FAILURE,
          });
        }
      } else {
        yield put({
          type: ReportActionTypes.ACTIVITY_TRACKING_REPORT_FAILURE,
        });
      }
    } else {
      toast.error("No content in the report", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      yield put({
        type: ReportActionTypes.ACTIVITY_TRACKING_REPORT_FAILURE,
      });
    }
  }
}

export default function* ReportSaga() {
  yield fork(weatherHistoryRequest);
  yield fork(watchCountRequest);
  yield fork(userInstallationRequest);
  yield fork(reviewsRequest);
  yield fork(ActivityTrackingRequest);
}
